import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { NgApiCommonModule } from '@n3/ng-api-common';
import { NgApiBaseKitModule, BaseService  } from '@n3/ng-api-base-kit';

import { TestingService } from '../services/testing.service';

import { TransferEnviromentService } from '../services/transferEnviroment.service';

@NgModule({
    declarations: [
        // Pipes.
        // Directives.
    ],
    exports: [
        // Pipes.
        // Directives.
    ],
    imports: [
        BrowserModule,
        NgApiCommonModule.forRoot(),
        NgApiBaseKitModule.forRoot(),
    ]
})
export class NgApiTestingModule {

    /**
     * Use in AppModule
     */
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: NgApiTestingModule,
            providers: [
                TestingService,
                BaseService,
                TransferEnviromentService
            ]
        };
    }

    /**
     * Use in features modules with lazy loading
     */
    public static forChild(): ModuleWithProviders {
        return {
            ngModule: NgApiTestingModule,
            providers: [
                TestingService,
                BaseService,
                TransferEnviromentService
            ]
        };
    }

}
